import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {AuthApiService} from './auth.api.service';
import {AbstractCrudApiService} from './abstract-crud.api.service';
import {full} from '../../../../../common/routes';
import {ApiService} from './api.service';
import {ME} from '../../../../../common/constants';

@Injectable()
export class UserApiService extends AbstractCrudApiService {

  protected apiUrl: string = full.user;

  constructor(http: HttpClient, authApi: AuthApiService, api: ApiService) {
    super(http, authApi, api);
  }

  public async getMe() {
    try {
      return await super.get(ME);
    } catch (err) {
      if (err.status === 404) {
        await this.authApi.logout();
      } else {
        throw err;
      }
    }
  }
}
